(function (global) {
  'use strict';

  var config = {
    version: 'carrco-2026-08-06-v2',
    productFormat: 'individual-stickers',
    minimum: 0.25,
    increment: 0.1,
    maximumWidth: 10,
    maximumHeight: 17,
    minimumQuantity: 1,
    maximumQuantity: 200000,
    minimumOrder: 26.49,
    referenceCost: 0.07,
    referenceArea: 9,
    unitFloor: 0.16,
    subOneSquareInchBaseFactor: 0.65,
    overThreeByThreeAreaRate: 0.1875,
    wasteRate: 0.1,
    handlingCost: 12.5,
    paymentRate: 0.029,
    paymentFixed: 0.3,
    contributionMargin: 0.35,
    anchors: [
      [1, 26.49, 26.49], [14, 26.49, 26.49], [25, 29.99, 35.99],
      [50, 49.99, 52.99], [100, 54.99, 73.99], [200, 64.99, 109.99],
      [300, 72.99, 134.99], [500, 87.99, 169.99], [600, 94.99, 189.99],
      [900, 112.99, 249.99], [1000, 119.99, 269.99], [2000, 171.99, 449.99],
      [3000, 218.99, 589.99], [5000, 301.99, 849.99], [10000, 479.99, 1599.99],
      [20000, 699.99, 3199.99], [100000, 1999.99, 15999.99], [200000, 3555.56, 31999.99]
    ]
  };

  function round(value, places) {
    var factor = Math.pow(10, places);
    return Math.round((value + Number.EPSILON) * factor) / factor;
  }

  function normalizeDimension(value) {
    var number = Number(value);
    if (!Number.isFinite(number)) throw new Error('Enter a valid size.');
    if (Math.abs(number - config.minimum) < 0.000001) return config.minimum;
    return round(Math.round(number / config.increment) * config.increment, 1);
  }

  function validate(input) {
    var shape = String(input.shape || 'custom').toLowerCase();
    var width = normalizeDimension(input.width);
    var height = normalizeDimension(input.height);
    if (shape === 'circle' || shape === 'square') height = width;
    if (width < config.minimum || height < config.minimum || width > config.maximumWidth || height > config.maximumHeight) {
      throw new Error('Width must be between 0.25 and 10 inches. Height must be between 0.25 and 17 inches.');
    }
    var quantity = Math.round(Number(input.quantity));
    if (!Number.isFinite(quantity) || quantity < config.minimumQuantity || quantity > config.maximumQuantity) {
      throw new Error('Quantity must be between 1 and 200,000.');
    }
    return { shape: shape, width: width, height: height, quantity: quantity, finish: input.finish === 'Matte' ? 'Matte' : 'Glossy' };
  }

  function monotoneSlopes(x, y) {
    if (x.length === 2) {
      var onlySlope = (y[1] - y[0]) / (x[1] - x[0]);
      return [onlySlope, onlySlope];
    }
    var h = [], delta = [], slopes = new Array(x.length).fill(0), index;
    for (index = 0; index < x.length - 1; index += 1) {
      h.push(x[index + 1] - x[index]);
      delta.push((y[index + 1] - y[index]) / h[index]);
    }
    for (index = 1; index < x.length - 1; index += 1) {
      if (delta[index - 1] === 0 || delta[index] === 0 || Math.sign(delta[index - 1]) !== Math.sign(delta[index])) {
        slopes[index] = 0;
      } else {
        var firstWeight = 2 * h[index] + h[index - 1];
        var secondWeight = h[index] + 2 * h[index - 1];
        slopes[index] = (firstWeight + secondWeight) / (firstWeight / delta[index - 1] + secondWeight / delta[index]);
      }
    }
    function endpoint(firstH, secondH, firstDelta, secondDelta) {
      var slope = ((2 * firstH + secondH) * firstDelta - firstH * secondDelta) / (firstH + secondH);
      if (Math.sign(slope) !== Math.sign(firstDelta)) return 0;
      if (Math.sign(firstDelta) !== Math.sign(secondDelta) && Math.abs(slope) > Math.abs(3 * firstDelta)) slope = 3 * firstDelta;
      return slope;
    }
    slopes[0] = endpoint(h[0], h[1], delta[0], delta[1]);
    var last = x.length - 1;
    slopes[last] = endpoint(h[last - 1], h[last - 2], delta[last - 1], delta[last - 2]);
    return slopes;
  }

  function smoothBetween(quantity, points, key) {
    if (quantity <= points[0].quantity) return points[0][key];
    if (quantity >= points[points.length - 1].quantity) return points[points.length - 1][key];
    var x = points.map(function(item){ return Math.log(item.quantity); });
    var y = points.map(function(item){ return Math.log(item[key]); });
    var slopes = monotoneSlopes(x, y), logQuantity = Math.log(quantity), lowerIndex = 0;
    while (logQuantity > x[lowerIndex + 1]) lowerIndex += 1;
    var interval = x[lowerIndex + 1] - x[lowerIndex];
    var position = (logQuantity - x[lowerIndex]) / interval;
    var position2 = position * position, position3 = position2 * position;
    var interpolatedLogPrice = (2 * position3 - 3 * position2 + 1) * y[lowerIndex] +
      (position3 - 2 * position2 + position) * interval * slopes[lowerIndex] +
      (-2 * position3 + 3 * position2) * y[lowerIndex + 1] +
      (position3 - position2) * interval * slopes[lowerIndex + 1];
    return Math.exp(interpolatedLogPrice);
  }

  function curve(quantity) {
    var points = config.anchors.map(function(anchor){return {quantity:anchor[0],one:anchor[1],three:anchor[2]};});
    var oneByOneTotal = smoothBetween(quantity, points, 'one');
    var threeByThreeTotal = smoothBetween(quantity, points, 'three');
    var rate = (threeByThreeTotal - oneByOneTotal) / 8;
    return { quantity: quantity, one: oneByOneTotal, three: threeByThreeTotal, setup: oneByOneTotal - rate, rate: rate };
  }

  function competitiveTotalForArea(priceCurve, area) {
    if (area <= 1) {
      var smallFactor = config.subOneSquareInchBaseFactor + (1 - config.subOneSquareInchBaseFactor) * area;
      return priceCurve.one * smallFactor;
    }
    if (area <= 9) return priceCurve.one + (priceCurve.three - priceCurve.one) * ((area - 1) / 8);
    var largeFactor = 1 + config.overThreeByThreeAreaRate * ((area - config.referenceArea) / config.referenceArea);
    return priceCurve.three * largeFactor;
  }

  function quote(input) {
    var valid = validate(input);
    var area = valid.width * valid.height;
    var priceCurve = curve(valid.quantity);
    var currentScale = competitiveTotalForArea(priceCurve, area);
    var printCost = config.referenceCost * (area / config.referenceArea) * valid.quantity;
    var knownCost = printCost * (1 + config.wasteRate) + config.handlingCost;
    var contributionFloor = (knownCost + config.paymentFixed) / (1 - config.paymentRate - config.contributionMargin);
    var scaledUnitFloor = config.unitFloor * (area / config.referenceArea);
    var highVolumeFloor = scaledUnitFloor * valid.quantity;
    var minimumSafeTotal = Math.max(contributionFloor, highVolumeFloor, config.minimumOrder);
    var total = round(Math.max(currentScale, minimumSafeTotal), 2);
    return {
      pricingVersion: config.version,
      productFormat: config.productFormat,
      currency: 'USD',
      shape: valid.shape,
      finish: valid.finish,
      widthInches: valid.width,
      heightInches: valid.height,
      quantity: valid.quantity,
      total: total,
      unitPrice: round(total / valid.quantity, 4),
      currentScaleTotal: round(currentScale, 2),
      minimumSafeTotal: round(minimumSafeTotal, 2),
      scaledMinimumUnitPrice: round(scaledUnitFloor, 4)
    };
  }

  global.CarrcoPricing = Object.freeze({ config: Object.freeze(config), normalizeDimension: normalizeDimension, validate: validate, quote: quote });
})(window);
